import { ASC_DIRECTION, DESC_DIRECTION } from '../common/constants/sort-by';

const sortDataBy = (event: any, field: string) => {
    const { direction } = event.detail;
    let sortBy;

    if (direction === ASC_DIRECTION) {
        sortBy = `${field} ${ASC_DIRECTION}`;
    } else if (direction === DESC_DIRECTION) {
        sortBy = `${field} ${DESC_DIRECTION}`;
    }

    return sortBy;
};

export default sortDataBy;
